import { useSelector } from "react-redux";
import { gotoUrl } from "utils/helpers";

import { paths } from "utils/constants";
import { makeSelectUserOrderEligibility } from "ducks/selectors/eligibilitySettings";

const useUserOrdersEligibilityAndRedirect = () => {
  const userHasActiveSIMOrder = !useSelector(makeSelectUserOrderEligibility());
  const redirect = () => {
    return gotoUrl(paths.MY_ORDERS, false, {}, false);
  };

  return userHasActiveSIMOrder ? redirect : () => {};
};

export default useUserOrdersEligibilityAndRedirect;
